module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "gridParent",
    class: {
      'reduce-ticks': _vm.reduceTicks
    },
    style: ({
      'pointer-events': (_vm.currentTool === 'Drag' || _vm.currentTool === 'Map') ? 'none' : 'auto'
    }),
    attrs: {
      "id": "grid"
    }
  }, [_c('svg', {
    ref: "grid",
    attrs: {
      "id": "svg-grid"
    }
  }, [_c('g', {
    staticClass: "axis axis--x"
  }), _vm._v(" "), _c('g', {
    staticClass: "axis axis--y"
  }), _vm._v(" "), _c('g', {
    staticClass: "images",
    attrs: {
      "data-transform-plz": ""
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "polygons",
    attrs: {
      "data-transform-plz": ""
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "walls",
    attrs: {
      "data-transform-plz": ""
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a8e9dfbe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grid/Grid.vue
// module id = 761
// module chunks = 2